"use client";

import { motion, useReducedMotion } from "framer-motion";
import * as React from "react";

import { steamIdleConfig } from "@/lib/animations";

interface SteamingPotProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function SteamingPot({ size = 40, className, ...props }: SteamingPotProps) {
  const prefersReduced = useReducedMotion();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      overflow="visible"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      focusable={false}
      {...props}
    >
      {/* Pot body */}
      <path d="M6 12v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8" />
      {/* Left handle */}
      <path d="M4 16H6" />
      {/* Right handle */}
      <path d="M18 16h2" />

      {/* Lid group — pops up and rocks from steam pressure */}
      <motion.g
        animate={prefersReduced ? undefined : steamIdleConfig.lid.animate}
        transition={steamIdleConfig.lid.transition}
        style={{ transformOrigin: "12px 12px" }}
      >
        <path d="M4 12h16" />
        <path d="M10 10h4" />
      </motion.g>

      {/* Steam wisps — positioned above lid with clearance for lid pop */}
      <motion.path
        d="M9 7c-1-1 1-3 0-4"
        animate={prefersReduced ? undefined : steamIdleConfig.wisp1.animate}
        transition={steamIdleConfig.wisp1.transition}
      />
      <motion.path
        d="M12 6c1-1-1-3 0-4"
        animate={prefersReduced ? undefined : steamIdleConfig.wisp2.animate}
        transition={steamIdleConfig.wisp2.transition}
      />
      <motion.path
        d="M15 7c-1-1 1-3 0-4"
        animate={prefersReduced ? undefined : steamIdleConfig.wisp3.animate}
        transition={steamIdleConfig.wisp3.transition}
      />
    </svg>
  );
}
